<template>
    <div>
        <v-progress-linear :indeterminate="true" v-if="loading"></v-progress-linear>
        <v-container v-else>
            <form @submit.prevent="add_towns" autocomplete="off">
                <v-layout row wrap>
                    <v-flex xs12 lg2 xl2 md3 sm4>
                        <v-select class="mx-1" clearable rounded filled :items="cities" v-model="towns.city_id" outlined
                            item-text="city_name" item-value="city_id" :return-object="false"
                            :label="$store.getters.lang.data.city_name">
                        </v-select>
                    </v-flex>

                    <v-flex xs12 lg2 xl2 md3 sm4>
                        <v-text-field v-model="towns.town_name" type="text" :label="$store.getters.lang.data.town_name"
                            outlined class="mx-1" filled required rounded>
                        </v-text-field>
                    </v-flex>


                    <!-- <v-flex xs12 lg2 xl2 md3 sm4>
                        <v-text-field v-model="towns.town_image" type="text"
                            :label="$store.getters.lang.data.town_image" outlined class="mx-1" filled required rounded>
                        </v-text-field>
                    </v-flex> -->


                    <v-flex xs12 lg2 xl2 md2 sm4>
                        <v-btn rounded color="primary" type="submit" x-large>{{$store.getters.lang.data.add_btn}} towns
                        </v-btn>
                    </v-flex>
                </v-layout>
            </form>
            <v-layout row wrap mt-5>
                <v-flex xs12>
                    <v-card>
                        <v-card-title primary-title>
                            {{$store.getters.lang.data.towns}}
                            <v-spacer></v-spacer>
                            <v-text-field autocomplete="off" v-model="search" append-icon="fas fa-search">
                            </v-text-field>
                        </v-card-title>
                        <v-card-text>
                            <v-data-table :headers="headers" :search="search" :items="rows" class="elevation-0"
                                item-key="town_id">
                                <template v-slot:[`item.town_id`]="{ item }">
                                    <div>
                                        <v-btn icon color="error" :disabled="$store.state.auth.user.admin_role != 'admin'" class="mx-1" @click="select_towns(item)" rounded>
                                            <v-icon>mdi-delete-outline</v-icon>
                                        </v-btn>
                                        <v-btn :to="'/towns-list/'+item.town_id" icon color="secondary" class="mx-1"
                                            rounded>
                                            <v-icon>mdi-pencil-outline</v-icon>
                                        </v-btn>
                                    </div>
                                </template>
                            </v-data-table>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
        <v-dialog v-model="delete_dialog" persistent max-width="290">
            <v-card>
                <v-card-title>
                    {{$store.getters.lang.data.delete_question}}
                </v-card-title>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="error" class="elevation-0" @click="delete_dialog = false">
                        {{$store.getters.lang.data.cancel_btn}}
                    </v-btn>
                    <v-btn color="green darken-1" text @click="delete_towns(selected_towns.town_id)">
                        {{$store.getters.lang.data.yes_btn}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-snackbar v-model="snackbar.value" :color="snackbar.color">
            {{snackbar.text}}
        </v-snackbar>
    </div>
</template>
<script>
    import controller from './../../controller/towns'
    export default {
        data() {
            return {
                towns: {},
                search: '',
                loading: true,
                snackbar: {
                    value: false,
                    text: '',
                    color: ''
                },
                selected_towns: {},
                delete_dialog: false,
                headers: [

                    


                    {
                        text: this.$store.getters.lang.data.city_name,
                        align: 'start',
                        sortable: true,
                        value: 'city_name',
                    },


                    {
                        text: this.$store.getters.lang.data.town_name,
                        align: 'start',
                        sortable: true,
                        value: 'town_name',
                    },


                    // {
                    //     text: this.$store.getters.lang.data.town_image,
                    //     align: 'start',
                    //     sortable: true,
                    //     value: 'town_image',
                    // },
                    {
                        text: this.$store.getters.lang.data.town_id,
                        align: 'start',
                        sortable: true,
                        value: 'town_id',
                    },


                ],
            }
        },
        computed: {
            rows() {
                return this.$store.getters.towns
            },

            cities() {
                return this.$store.getters.cities
            },


        },
        mounted() {
            this.read_towns();
        },
        methods: {
            add_towns() {
                controller.add_towns(this.towns).then(r => {
                    if (r.data) {
                        this.towns = {}
                        this.$store.state.towns.push(
                            r.data.new_data
                        )
                        this.snackbar = {
                            value: true,
                            text: 'towns Added',
                            color: 'success'
                        }
                    } else {
                        this.snackbar = {
                            value: true,
                            text: 'Fail to add towns',
                            color: 'error'
                        }
                    }
                })
            },
            delete_towns(town_id) {
                controller.delete_towns(town_id).then(r => {
                    this.delete_dialog = false
                    if (r.data) {
                        this.$store.state.towns = this.$store.state.towns.filter(f => {
                            return f.town_id != town_id
                        })
                        this.snackbar = {
                            value: true,
                            text: 'towns Deleted',
                            color: 'success'
                        }
                    } else {
                        this.snackbar = {
                            value: true,
                            text: 'Delete Faild',
                            color: 'error'
                        }
                    }
                })
            },
            read_towns() {
                this.loading = true
                controller.get_towns().then(r => {
                    // this.rows = r.data.rows
                    this.loading = false
                })
            },
            select_towns(i) {
                this.selected_towns = i
                this.delete_dialog = true
            },
        },
    }
</script>